import { cloudinaryMedium } from "./cloudinaryUrls";

export const generateImgUrl = (filename: string): string =>
  !filename || filename.includes("https://")
    ? filename
    : `${cloudinaryMedium}${filename}`;
